import { createExporter } from "utils/createExporter";
import {
  DEPARTMENTS,
  DIRECTIONS,
  EMPLOYEES,
  POSITIONS,
  PROFESSIONAL_DIRECTIONS,
  SCIENTIFIC_DEGREES,
  STRUCTURAL_UNITS,
  POSITION_TYPES,
} from "utils/constants";
import { determineGender } from "../../utils/helpers";
import { employeeRequests } from "api/employeeApi";
import { administrationRequests } from "api/administrationApi";

const NAME_COLUMNS = [
  { key: "nameBg", label: "име на български" },
  { key: "nameEn", label: "име на английски" },
];

const DEPARTMENTS_COLUMNS = [...NAME_COLUMNS, { key: "structuralUnit", label: "структурна единица" }];

const DIRECTIONS_COLUMNS = [
  ...NAME_COLUMNS,
  { key: "providesCampaigns", label: "КСК" },
  { key: "canCandidateWithDifferentExams", label: "КСК с различни изпити" },
];

const EMPLOYEES_COLUMNS = [
  { key: "externalEmail", label: "Google Workspace имейл" },
  { key: "firstName", label: "име" },
  { key: "secondName", label: "презиме" },
  { key: "lastName", label: "фамилия" },
  { key: "gender", label: "пол" },
  { key: "personId", label: "ЕГН" },
];

const POSITIONS_COLUMNS = [
  { key: "nameBg", label: "име на български" },
  { key: "type", label: "тип позиция" },
];

const POSITION_TYPES_COLUMNS = [...NAME_COLUMNS];

const PROFESSIONAL_DIRECTIONS_COLUMNS = [{ key: "nameBg", label: "име на български" }];

const SCIENTIFIC_DEGREES_COLUMNS = [
  { key: "nameBgShort", label: "име на български език" },
  { key: "nameBg", label: "пълно име на български език" },
  { key: "nameEnShort", label: "име на английски език" },
  { key: "nameEn", label: "пълно име на английски език" },
];

const STRUCTURAL_UNITS_COLUMNS = [
  ...NAME_COLUMNS,
  { key: "direction", label: "направление" },
  { key: "hasSpecialGroup", label: "предлага специална група" },
];

export const AdministrationExporter = type => {
  const columnsMap = {
    [DEPARTMENTS]: DEPARTMENTS_COLUMNS,
    [DIRECTIONS]: DIRECTIONS_COLUMNS,
    [EMPLOYEES]: EMPLOYEES_COLUMNS,
    [POSITIONS]: POSITIONS_COLUMNS,
    [POSITION_TYPES]: POSITION_TYPES_COLUMNS,
    [PROFESSIONAL_DIRECTIONS]: PROFESSIONAL_DIRECTIONS_COLUMNS,
    [SCIENTIFIC_DEGREES]: SCIENTIFIC_DEGREES_COLUMNS,
    [STRUCTURAL_UNITS]: STRUCTURAL_UNITS_COLUMNS,
  };

  const mapperMap = {
    [DEPARTMENTS]: record => ({
      ...record,
      structuralUnit: record.structuralUnit?.name,
    }),

    [DIRECTIONS]: record => ({
      ...record,
      providesCampaigns: record.providesCampaigns ? "Да" : "Не",
      canCanidateWithDifferentExams: record.canCanidateWithDifferentExams ? "Да" : "Не",
    }),

    [EMPLOYEES]: record => ({
      externalEmail: record.userInfo?.externalEmail,
      firstName: record.userInfo?.firstName,
      secondName: record.userInfo?.secondName,
      lastName: record.userInfo?.lastName,
      gender: determineGender(record.userInfo?.gender),
      personId: record.userInfo?.personId,
    }),

    [POSITIONS]: record => ({
      ...record,
      type: record.positionType?.name,
    }),

    [POSITION_TYPES]: record => ({
      ...record,
    }),

    [PROFESSIONAL_DIRECTIONS]: record => ({
      ...record,
    }),

    [SCIENTIFIC_DEGREES]: record => ({
      ...record,
    }),

    [STRUCTURAL_UNITS]: record => ({
      ...record,
      direction: record.direction?.name,
      hasSpecialGroup: record.hasSpecialGroup ? "Да" : "Не",
    }),
  };

  const relationMap = {
    [DEPARTMENTS]: [
      {
        source: "structuralUnitId",
        target: administrationRequests.getStructuralUnitsSelect(),
        name: "structuralUnit",
      },
    ],

    [DIRECTIONS]: DIRECTIONS_COLUMNS,

    [EMPLOYEES]: EMPLOYEES_COLUMNS,

    [POSITIONS]: [
      {
        source: "typeId",
        target: employeeRequests.getPositionTypesSelect(),
        name: "positionType",
      },
    ],

    [STRUCTURAL_UNITS]: [
      {
        source: "directionId",
        target: administrationRequests.getDirectionsSelect(),
        name: "direction",
      },
    ],
  };

  const columns = columnsMap[type];

  const mapper = mapperMap[type] || (r => r);

  const relations = relationMap[type] || [];

  const fileName = type.replace(/[-/]/g, "_");

  return createExporter(`administration_${fileName}.xlsx`, columns, mapper, relations);
};
